module.exports = __webpack_public_path__ + "static/media/birthday.c9307cff.svg";